var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrRightViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back Button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3429 5.71696C11.0756 5.44975 10.6422 5.44984 10.375 5.71696C10.1076 5.98436 10.1076 6.41767 10.3751 6.68506L13.0052 9.31512L5.38881 9.31585C5.01081 9.31594 4.70444 9.6223 4.70444 10.0005C4.70453 10.3785 5.0109 10.6848 5.3889 10.6848L13.0056 10.684L10.3748 13.3146C10.1075 13.5819 10.1075 14.0154 10.3748 14.2827C10.5085 14.4163 10.6836 14.4832 10.8588 14.4832C11.034 14.4832 11.2091 14.4163 11.3428 14.2827L15.1419 10.4837C15.2703 10.3554 15.3424 10.1814 15.3424 9.99976C15.3423 9.81815 15.2702 9.64421 15.1418 9.51562L11.3429 5.71696Z",
    fill: "#730BDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrRightViolet);
export default __webpack_public_path__ + "static/media/arr-right-violet.2de7d476b59cd63590e08d17a8b1e6ef.svg";
export { ForwardRef as ReactComponent };